import { Component, Input, NgModule } from '@angular/core';
import { Cms } from '@impact/data';

import { UspModule } from '../../usp/usp.module';
import { SpotBaseDirective } from '../spot-base.class';

@Component({
    selector: 'app-usp-spot',
    template: '<app-usp [items]="data?.uspItems"></app-usp>',
})
class UspSpotComponent extends SpotBaseDirective {
    @Input() data?: Cms.UspSpot;
}

@NgModule({
    declarations: [UspSpotComponent],
    imports: [
        UspModule
    ]
})
class UspSpotModule {}

export const LazySpotComponent = UspSpotComponent;
